import { useSelector } from "react-redux";

import { TooltipDesc, TooltipName } from "components/base/Tooltip";
import { getPlanetData } from "libs/stats";
import { getLocationInfo } from "redux/selectors/characterSelectors";

const TooltipPlanet = () => {
  const { planet } = useSelector(getLocationInfo);
  const { name: planetName } = getPlanetData(planet);

  return (
    <>
      <TooltipName>Current Planet</TooltipName>
      <TooltipDesc>
        You are currently on {planetName}. You can travel to different planets
        by visiting the Jump Gate at the nearest city.
      </TooltipDesc>
    </>
  );
};

export default TooltipPlanet;
